import * as amplitude from "@amplitude/analytics-browser";

const API_KEY = import.meta.env.REACT_APP_ENV === "production" ?
  import.meta.env.REACT_APP_AMPLITUDE_LIVE_KEY : import.meta.env.REACT_APP_AMPLITUDE_STAGING_KEY;

amplitude.init(API_KEY, {
  defaultTracking: {
    attribution: false,
    pageViews: false,
    sessions: false,
    formInteractions: false,
    fileDownloads: false,
  },
});
